/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Fee info per asset
 */
export interface AssetFeeInfo {
  asset: Asset;
  exchangeWithdrawalFee?: number;
  exchangeWithdrawalFeeInUsd?: number;
  networkFee?: number;
  networkFeeInUsd?: number;
}
